<style lang="scss">
.overlay {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.4);

    .form {
        position: relative;
        flex: 0 0 70%;
        padding: 24px;
        background: #FFFFFF;
        box-shadow: 0px 1px 4px rgba(21, 34, 50, 0.08);
        border-radius: 5px;

        :global(.close) {
            position: absolute;
            top: 8px;
            right: 8px;
        }
    }
}
</style>
<script lang="ts" context="module">
export interface PersonEventDetail {
    person: Person;
    isNew: boolean;
}
export type PersonEvent = CustomEvent<PersonEventDetail>;
</script>
<script lang="ts">
import { createEventDispatcher } from 'svelte';
import { fade, scale } from 'svelte/transition';
import { cubicOut } from 'svelte/easing';
import type { Person } from '../api/types';
import PersonForm from './Person.svelte';
import CloseControl from './CloseControl.svelte';

export let person: Person | undefined;
const dispatch = createEventDispatcher();

function onPersonCreate(evt: CustomEvent<Person>) {
    notify(evt.detail, true);
}

function onPersonEdit(evt: CustomEvent<Person>) {
    notify(evt.detail, false);
}

function notify(value: Person, isNew = false) {
    person = value;
    dispatch('update', { person, isNew } as PersonEventDetail);
}
</script>
<div class="overlay" transition:fade="{{duration: 200}}">
    <div class="form" transition:scale="{{duration: 200, start: 0.5, easing: cubicOut}}">
        <CloseControl on:click={() => dispatch('close')} />
        <PersonForm {person}
            on:create={onPersonCreate}
            on:update={onPersonEdit} />
    </div>
</div>
